var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 14.166C10.5027 14.166 11.9441 13.569 13.0068 12.5063C14.0695 11.4436 14.6665 10.0022 14.6665 8.49935C14.6665 6.99646 14.0695 5.55512 13.0068 4.49241C11.9441 3.4297 10.5027 2.83268 8.99984 2.83268C7.49694 2.83268 6.0556 3.4297 4.9929 4.49241C3.93019 5.55512 3.33317 6.99646 3.33317 8.49935C3.33317 10.0022 3.93019 11.4436 4.9929 12.5063C6.0556 13.569 7.49694 14.166 8.99984 14.166ZM8.99984 1.41602C9.93003 1.41602 10.8511 1.59923 11.7105 1.9552C12.5699 2.31117 13.3508 2.83293 14.0085 3.49068C14.6663 4.14842 15.188 4.92928 15.544 5.78867C15.9 6.64806 16.0832 7.56915 16.0832 8.49935C16.0832 10.378 15.3369 12.1796 14.0085 13.508C12.6801 14.8364 10.8785 15.5827 8.99984 15.5827C5.08275 15.5827 1.9165 12.3952 1.9165 8.49935C1.9165 6.62073 2.66278 4.81906 3.99116 3.49068C5.31955 2.16229 7.12122 1.41602 8.99984 1.41602ZM9.354 4.95768V8.67643L12.5415 10.5677L12.0103 11.4389L8.2915 9.20768V4.95768H9.354Z",
    fill: "url(#paint0_linear_6089_348904)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6089_348904",
    x1: 8.99984,
    y1: 1.41602,
    x2: 8.99984,
    y2: 15.5827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6064FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardClock);
export default __webpack_public_path__ + "static/media/leaderboard-clock.1140a824c76c0c95608cdb0206406841.svg";
export { ForwardRef as ReactComponent };